<template>
  <div v-html="html" />
</template>

<script>
import prismicDOM from 'prismic-dom';
import linkResolver from '@/prismic/link-resolver';

export default {
  name: 'RichText',
  props: {
    field: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    html() {
      if (!this.field || !this.field.length) {
        return null;
      }

      // This checks is prismic node starts with `<`.
      // If it does if just returns text, cause it should be html.
      // Otherwise it builds an array of prismic nodes so later we can call prismic.asHtml on it.
      const extractHtml = this.field.reduce((extracted, node) => {
        if (node.text && node.text[0] === '<') {
          return [...extracted, node.text];
        } else if (Array.isArray(extracted[extracted.length - 1])) {
          extracted[extracted.length - 1].push(node);
          return extracted;
        } else {
          return [...extracted, [node]];
        }
      }, []);

      return extractHtml
        .map(slice => {
          if (Array.isArray(slice)) {
            return prismicDOM.RichText.asHtml(slice, linkResolver);
          } else {
            return slice;
          }
        })
        .join('')
        .replace(/`([^`<>]+)`/g, '<code>$1</code>');
    }
  }
};
</script>
